module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bill-template-blank-form', {
    attrs: {
      "submit-label": "Добавить шаблон квитанции",
      "bill-template": _vm.bill_template,
      "errors": _vm.errors,
      "form-type": "add"
    },
    on: {
      "submit": _vm.processForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-078812d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/bill_template/BillTemplateAddForm.vue
// module id = 572
// module chunks = 0